module.exports = __webpack_public_path__ + "static/appTabImg5-596f5ed839ef0e8a6719e17777aafceb.png";